import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";
import dataService from "../../api";
import { status } from "@/utils/common";


export default {
    namespaced: true,
    state: {
        paymentAccounts: [],
        paymentAccount: {},
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.paymentAccounts.findIndex(i => i.id === id)
    },
    mutations: {
        SET_paymentAccounts: (state, data) => state.paymentAccounts = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_paymentAccount: (state, viewData) => state.paymentAccount = viewData,
        ADD: (state, addedData) => state.paymentAccounts.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.paymentAccounts.splice(index, 1, updateData),
        DELETE: (state, index) => state.paymentAccounts.splice(index, 1),
        lock: (state, index) => state.paymentAccounts[index].status = status.locked,
        unlock: (state, index) => state.paymentAccounts[index].status = status.active,

    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.paymentAccounts.getAll(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_paymentAccounts', response.data.paymentAccounts);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SET_paymentAccount', {});
                const response = await dataService.paymentAccounts.getDetails(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_paymentAccount', response.data.paymentAccount);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getForEdit(_, id) {
            startLoading();
            try {

                const response = await dataService.paymentAccounts.getForEdit(id);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                return Promise.resolve(response.data.paymentAccount);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },

        async add({ commit }, payload) {
            try {
                startLoading()
                const response = await dataService.paymentAccounts.add(payload);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);
                commit("ADD", response.data.paymentAccount);


            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async edit({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.paymentAccounts.edit(id, payload);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.paymentAccount });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
            }
        },
        async delete({ commit, getters }, id) {
            startLoading()
            try {
                const response = await dataService.paymentAccounts.delete(id);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async lock({ commit, getters }, id) {
            try {
                startLoading()
                const response = await dataService.paymentAccounts.lock(id);
                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);


                const index = getters.index(id);
                commit("lock", index);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async unlock({ commit, getters }, id) {
            try {
                startLoading()
                const response = await dataService.paymentAccounts.unlock(id);

                stopLoading()

                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                showNotification(response.data.message);

                const index = getters.index(id);
                commit("unlock", index);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
    },
};
